export default "__VITE_ASSET__Bboplcun__"